import { useMyTalentDrafts } from "./useMyTalentDrafts";

export function useMyTalentDraft() {
  return useMyTalentDrafts((state) =>
    state.talentDrafts.length ? state.talentDrafts[0] : undefined
  );
}
